module.exports = __webpack_public_path__ + "media/2.5ba7543a.mp3";